import React from 'react';
import { FaSearch } from "react-icons/fa";
const Lupa = () => {
  return(
    <div>
      <a href='/comidas/all'><FaSearch /></a>
    </div>
  )
}

export { Lupa }